import AbsComponent from '../../common/components/AbsComponent';
import GetsearchresultTempl from "./GetsearchresultTempl";
import PagingTempl from "./PagingTempl";


/**
 * Sub1 class
 * @category testApp
 */
class Getsearchresult extends AbsComponent{
    constructor(_store={}){
        super(_store);
    }

    render(_jsonData = {}){
        $('.search-result-inner').html(GetsearchresultTempl.getSearchResultTempl(_jsonData,this.store.data.config));
        $('.search-filter-count .count').html(_jsonData.pagination.total+ '건');
        $('.ui-paging').html(PagingTempl.getPagingTempl(_jsonData,this.store.data.config));

        this.addEvents();
    }

    setting(_searchQuery, _d){
        //_searchQuery += '&page=';
        this.store.getResultInfoData(_searchQuery, this.render.bind(this));
    }

    addEvents(_d){
        $('.search-result-inner .loading-wrap').removeClass('is-show');
    }
}

export default Getsearchresult;